import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthLayout, FieldLabel } from '@/components/AuthLayout';
import { requestPasswordReset } from '@/lib/auth';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pending, setPending] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pending) return;

    setPending(true);
    await requestPasswordReset(email);
    setPending(false);

    /*
     * The same screen follows no matter what happened — an account, no account,
     * or a request that never arrived. Anything else would let this form be used
     * to test which addresses belong to the studio, which is exactly what the
     * server refuses to reveal.
     *
     * The address travels in router state rather than the URL: it is only there
     * to be shown back, and a query string would put it in history and in any
     * link that gets shared from that page.
     */
    navigate('/forgot-password/sent', { state: { email }, replace: true });
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter the email you use for the studio account and we will send a reset link."
      footnote="The link works once and expires after 30 minutes."
    >
      <form className="flex flex-col gap-4" onSubmit={submit}>
        <label className="flex flex-col gap-[7px]">
          <FieldLabel>Work email</FieldLabel>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="you@sonasi.app"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="field field-auth"
          />
        </label>
        <button
          type="submit"
          disabled={pending}
          className="btn-accent focus-ring min-h-[42px] cursor-pointer p-[11px] text-sm disabled:cursor-wait disabled:opacity-70"
        >
          {pending ? 'Sending…' : 'Send reset link'}
        </button>
        <button
          type="button"
          onClick={() => navigate('/login')}
          className="btn-quiet focus-ring min-h-[32px] cursor-pointer p-1 text-[13.5px]"
        >
          ← Back to sign in
        </button>
      </form>
    </AuthLayout>
  );
}
